<div class="w-100 expire-password-container">
  <div class="w-100 px-plus expire-password-content">
    <div class="w-100 expire-password-header">
      <app-makna-header
        [title]="'ساختن رمز عبور جدید'"
        [backUrl]="backUrl"
      />
    </div>
    <div class="w-100 expire-password-description">
      <span>برای حساب کاربری خود رمز عبور جدید بسازید.</span>
    </div>
    <div class="w-100 expire-password-old-password">
      <app-password-input
        [displayIndicator]="false"
        [passwordInfo]="passwordInfo"
        [inputPlaceholder]="'رمز عبور قبلی'"
        (onInputChanged)="onOldPasswordValueChanged($event)"
      ></app-password-input>
      @if (oldPasswordWrong) {
        <span class="old-password-wrong"> رمز عبور قبلی اشتباه است </span>
      }
    </div>
    <div class="w-100 expire-password-complexity">
      <app-password-complexity
        (onPasswordChanged)="onPasswordChanged($event)"
        (onRepeatPasswordChanged)="onRepeatPasswordChanged($event)"
      ></app-password-complexity>
    </div>
    <div class="w-100 expire-password-button"></div>
    <ngx-button
      [fullWidth]="true"
      (clickHandler)="onSubmit()"
      [disabled]="
        password?.value?.length < 8 ||
        passwordRepeat?.value?.length < 8 ||
        oldPassword?.value?.length < 8 ||
        oldPasswordWrong ||
        password?.complexity < 2 ||
        passwordRepeat?.complexity < 2 ||
        loading
      "
    >
      تایید و ادامه
    </ngx-button>
  </div>
</div>
